// GET
export const GET_LIST_CHOICE = "GET_LIST_CHOICE"
export const GET_LIST_CHOICE_SUCCESS = "GET_LIST_CHOICE_SUCCESS"
export const GET_LIST_CHOICE_BY_ID = "GET_LIST_CHOICE_BY_ID"
export const GET_LIST_CHOICE_BY_ID_SUCCESS = "GET_LIST_CHOICE_BY_ID_SUCCESS"
// POST
export const POST_LIST_CHOICE = "POST_LIST_CHOICE"
export const POST_LIST_CHOICE_SUCCESS = "POST_LIST_CHOICE_SUCCESS"
// PATCH
export const PATCH_LIST_CHOICE_BY_ID = "PATCH_LIST_CHOICE_BY_ID"
export const PATCH_LIST_CHOICE_BY_ID_SUCCESS = "PATCH_LIST_CHOICE_BY_ID_SUCCESS"
// DELETE
export const DELETE_LIST_CHOICE_BY_ID = "DELETE_LIST_CHOICE_BY_ID"
export const DELETE_LIST_CHOICE_BY_ID_SUCCESS = "DELETE_LIST_CHOICE_BY_ID_SUCCESS"
